import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { IResponseGetFiles } from '~/utils/interface/customer';
import {
  IEditFolder,
  IParamGetFileFromFolder,
  IPayloadDeleteFolder,
  IResponseGetFolderDetail,
  IResponseGetFolders,
} from '~/utils/interface/folder';

const folderApi = {
  getFolders() {
    return axiosClient.get<IApiBaseResponse<IResponseGetFolders>>('api/admin/folders');
  },

  createFolder(data: IEditFolder) {
    return axiosClient.post<IApiBaseResponse<IResponseGetFolderDetail>>('api/admin/folders', data);
  },

  getFolder(id: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFolderDetail>>(`api/admin/folders/${id}`);
  },

  updateFolder(id: string | number, data: IEditFolder) {
    return axiosClient.put<IApiBaseResponse<null>>(`api/admin/folders/${id}`, data);
  },

  deleteFolder(data: IPayloadDeleteFolder) {
    const url = `api/admin/folders`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },

  getFilesFromFolder(folderId: string | undefined, params: IParamGetFileFromFolder) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFiles>>(`api/admin/folders/${folderId}/files`, {
      params,
    });
  },
};

export default folderApi;
